let currentUserId: string | undefined
export const getUserId = () => {
  return currentUserId
}

export const setUserId = (id: string) => {
  currentUserId = id
}

export const removeUserId = () => {
  currentUserId = undefined
}
